import * as React from 'react';

export interface QuizResultsHeaderContainerProps {
  children: React.ReactNode;
}

export function QuizResultsHeaderContainer({
  children,
}: QuizResultsHeaderContainerProps) {
  return <div className="flex flex-col gap-4 pb-4">{children}</div>;
}
